export const params = {
  applicationId: 'aid',
  token: 't',
};

export const paramsLegacy = {
  // backwards compatibility
  applicationId: 'id',
  token: 'token',
};
